import { imageURL } from '@everlane/media'

export default {
  imageUrl: function (path = '', options = {}) {
    return imageURL(path, options)
  },
}
